import script from "./bodyContain.vue?vue&type=script&setup=true&lang=js"
export * from "./bodyContain.vue?vue&type=script&setup=true&lang=js"

import "./bodyContain.vue?vue&type=style&index=0&id=b48337ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b48337ec"]])

export default __exports__